import { Tags } from './';
import { ExternalLink } from '@app/shared/ui/atoms/Common';
import { instagramIcon, telegramIcon } from '@app/assets';

interface BottomBarProps {
  tags: string[];
  instagram?: string | null;
  telegram?: string | null;
}

const baseInstagramImgAttrs = { src: instagramIcon, alt: 'instagram', width: 27 } as const;
const baseTelegramImgAttrs = { src: telegramIcon, alt: 'telegram', width: 27 } as const;

export function BottomBar({ tags, instagram, telegram }: BottomBarProps) {
  return (
    <div className="flex justify-between gap-2">
      <Tags tags={tags} />
      <div className="flex h-fit shrink-0 items-center gap-2">
        {instagram ? (
          <ExternalLink url={`instagram.com/${instagram}`}>
            <img {...baseInstagramImgAttrs} />
          </ExternalLink>
        ) : (
          <img {...baseInstagramImgAttrs} className="opacity-50" />
        )}
        {telegram ? (
          <ExternalLink url={`t.me/${telegram}`}>
            <img {...baseTelegramImgAttrs} />
          </ExternalLink>
        ) : (
          <img {...baseTelegramImgAttrs} className="opacity-50" />
        )}
      </div>
    </div>
  );
}
